import { castToSnapshot, types } from 'mobx-state-tree';
import { createThunk, ListModel, model } from 'mst-collection';

import { Api, schemas } from '@api';
import { TutorialModel } from './TutorialModel';
import {
  handleFlow,
  shouldRejectPagination,
  ThunkAbortController,
} from '../utils';

export class SearchedTutorialList extends ListModel(
  types.reference(TutorialModel),
  {
    idAttribute: 'id',
    schema: schemas.TutorialListSchema,
    pageSize: 20,
  },
) {
  private _fetchAbortController = new ThunkAbortController();

  fetch = createThunk((queryParam: string) => {
    return async function fetch(this: SearchedTutorialList) {
      try {
        // Cancel previous request if it in progress
        this._fetchAbortController.abort();

        const res = await Api.Hub.searchTutorials(
          {
            query: queryParam,
            count: this.pageSize,
            start: 0,
          },
          this._fetchAbortController.create(),
        );

        this.set(res.data.videos);

        this._fetchAbortController.remove();

        return res.data;
      } catch (error) {
        // If request was canceled do nothing
        if (ThunkAbortController.isCanceled(error)) {
          return;
        }

        throw error;
      }
    };
  });

  fetchMore = createThunk((queryParam: string) => {
    return async function fetchMore(
      this: SearchedTutorialList,
      flow,
    ) {
      if (shouldRejectPagination(this)) {
        return;
      }

      const result = await handleFlow(flow, async () => {
        const res = await Api.Hub.searchTutorials({
          query: queryParam,
          count: this.pageSize,
          start: this.offset,
        });
        this.append(castToSnapshot(res.data.videos));

        return res.data;
      });

      return result;
    };
  }, false);
}

export const SearchedTutorialListModel = model(SearchedTutorialList);
